import React, { useEffect, useState } from "react";
import content from "../content/content.json";

const ExpertiseSection = () => {
  const [offsetX, setOffsetX] = useState(0);
  const { expertiseSection } = content;

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setOffsetX(scrollY * 0.3);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className="relative flex flex-col md:flex-row items-center justify-center w-full bg-white overflow-hidden py-16 md:py-20 px-6 md:px-20">
      <div
        className="absolute inset-0 flex items-center justify-center w-full text-[25vw] md:text-[22vw] font-black text-[#F5F8FA] whitespace-nowrap leading-none tracking-tighter pointer-events-none select-none"
        style={{
          transform: `translateX(${offsetX}px)`,
          transition: "transform 0.15s linear",
        }}
      >
        <span>{expertiseSection.watermark}</span>
      </div>

      <div className="relative z-10 flex flex-col md:flex-row items-start justify-between w-full max-w-7xl gap-8 md:gap-12">
        <div className="w-full md:w-1/2">
          <h3 className="text-lg font-semibold text-gray-600 mb-3">{expertiseSection.eyebrow}</h3>
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#1C1F2B] leading-tight">{expertiseSection.title}</h2>
        </div>

        <div className="w-full md:w-1/2 text-base md:text-lg text-gray-600 leading-relaxed max-w-xl mb-4 mt-8">
          <p>{expertiseSection.description}</p>
        </div>
      </div>
    </section>
  );
};

export default ExpertiseSection;

